import React from 'react';
import { Card } from '../ui/card';
import { cn } from '../../lib/utils';

export const KpiCard = ({ label, value, icon: Icon, accent = 'primary', sub, testId }) => {
  const accentMap = {
    primary: 'bg-primary/10 text-primary',
    free: 'bg-pos-free/10 text-pos-free',
    ordered: 'bg-pos-ordered/10 text-pos-ordered',
    bill: 'bg-pos-bill/10 text-pos-bill',
    accent: 'bg-accent/10 text-accent',
  };
  return (
    <Card className="p-4 flex items-center gap-4" data-testid={testId}>
      {Icon && (
        <div className={cn('h-12 w-12 rounded-xl flex items-center justify-center shrink-0', accentMap[accent])}>
          <Icon className="h-6 w-6" />
        </div>
      )}
      <div className="min-w-0">
        <div className="text-sm text-muted-foreground truncate">{label}</div>
        <div className="text-2xl md:text-3xl font-display font-semibold tabular leading-tight">{value}</div>
        {sub && <div className="text-xs text-muted-foreground truncate">{sub}</div>}
      </div>
    </Card>
  );
};
